import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-products-faqs',
  templateUrl: './products-faqs.component.html',
  styleUrls: ['./products-faqs.component.scss']
})
export class ProductsFaqsComponent {
  faqs: any[] = [];

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ProductsFaqsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.faqs = data.faqs || [];
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
